<template>
	<!-- 			:touchable="false" -->
	<div class="step-one">
        <Swipe
            ref="swipe"
            vertical
            :loop="false"
			:touchable="touchable"
            :initial-swipe="index"
            :show-indicators="false"
            :stop-propagation="false"
			@change="onChange"
        >
            <SwipeItem class="swipe-item step_one" @scroll="getHeight" @touchmove="move" @touchstart="start" >
                <HeaderVertical title="【大有】6月26日公测邀请函" :haveHeight="true" url="transparent"></HeaderVertical>
				<div class="sincerely" v-if="name" >
					<div class="sincerely_title" >诚邀</div>
					<div class="sincerely_name" >{{name}}</div>
				</div>
                <img class="bg" src="https://oss01.dayou.art/dayouwx/interior-invitation-step1-2.png" alt="大有邀请函">
                <img class="icon-arrow" @click="handle_swipe_next" src="https://oss01.dayou.art/interior-invitation-step1-arrow.png" alt="大有邀请函">
            </SwipeItem>

            <SwipeItem class="swipe-item step-two" @scroll="getHeight" @touchmove="move" @touchstart="start" >
                <HeaderVertical title="【大有】6月26日公测邀请函" :haveHeight="true" url="transparent"></HeaderVertical>
				<img class="step2-img1" src="https://oss01.dayou.art/interior-invitation-step2-1.png" alt="大有邀请函">
				<div class="flex step2-footer" >
					<img class="step2-img2" src="https://oss01.dayou.art/interior-invitation-step2-img1-1.png" alt="大有邀请函">
					<div class="step2-video-box">
					    <video
					        class="step2-video"
					        src="https://video-qn.51miz.com/preview/video/00/00/13/21/V-132121-CB108272.mp4"
					        width="100%"
					        muted
					        loop
					        autoplay
					    ></video>
					</div>
				</div>
				
				<!-- <img class="step2-img1" src="https://oss01.dayou.art/interior-invitation-step2-1.png" alt="大有邀请函">
				<img class="step2-img2" src="https://oss01.dayou.art/interior-invitation-step2-img1-1.png" alt="大有邀请函">
				<div class="step2-video-box">
				    <video
				        class="step2-video"
				        src="https://video-qn.51miz.com/preview/video/00/00/13/21/V-132121-CB108272.mp4"
				        width="100%"
				        muted
				        loop
				        autoplay
				    ></video>
				</div> -->

                <div class="btn-receive" @click="handle_receive">{{vip_checkin_status ? '已领取' : '领取'}}</div>
            </SwipeItem>
        </Swipe>

        <Login v-if="showLogin" title="绑定手机号" @login="login"></Login>
    </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant';
import { promote_checkin , status_checkin } from '@/api/invitation'
import Login from '@/components/common/login/login';
export default {
    components: {
        Swipe,
        SwipeItem,
        Login,
    },
	data() {
		return {
            index: 0,
            showLogin: false, // 是否显示登录组件
            vip_checkin_status: 0, // vip领取状态0未领1已领
			touchable:true,//是否默认滚动
			change_index:0,
			status:false,
			scroll_status:true,
			toch_status:true,
			event_height:0,
			name:""
        };
	},
    created () {
        this.status_checkin()
    },
    computed: {
        navHeight () {
            return this.$store.getters['page/get_navHeight']
        },
    },
	methods: {
        // 切换到下一轮播
        handle_swipe_next () {
            // const ele  = document.getElementsByClassName('step-two')[0]
			this.$refs.swipe.swipeTo(1)
			this.onChange(1)
            // ele.scrollIntoView({
            //     behavior: 'smooth',
            //     block: 'start',
            // })
        },
		//滑动
		onChange(index){
			this.change_index=index
			// this.status=true
			this.touchable=false
			this.scroll_status=true
			// this.$refs.swipe.prev()
		},
		//返回到上一页
		return_step(){
			this.touchable=true
			// this.status=false
			this.change_index=0
			this.$refs.swipe.swipeTo(0)
			//console.log('返回上一页')
		},
		getHeight(e){
			const height = Number(e.srcElement.scrollTop.toFixed(0))
			const top=Number(e.srcElement.clientHeight)
			const scrollHeight= e.srcElement.scrollHeight
			if(height==0&&this.change_index==1||height+top==scrollHeight&&this.change_index==0){
				this.scroll_status=true
			}else{
				this.scroll_status=false
			}
		},
		start(e){
			const event = e.changedTouches[0]
			this.event_height = event.pageY
		},
		move(e){
			if(!this.scroll_status) return
			const event = e.changedTouches[0]
			if(event.pageY+150<this.event_height&&this.change_index==0){
				this.handle_swipe_next()
			}
			if(event.pageY>this.event_height+150&&this.change_index==1){
				this.return_step()
			}
			
			
		},
		// 校验登录
		verify_login() {
			const token = localStorage.getItem('token');
			if (!token) {
				this.$toast({
					type: 'fail',
					message: '请先登录',
				});
				this.showLogin = true;
			}

			return !!token;
		},
		// 登录
		login(status) {
			this.showLogin = false;
			if (status) this.handle_receive(); // 登录成功自动领取
		},
        // 获取vip领取状态
        get_vip_checkin_status () {
            const vip_checkin_status = localStorage.getItem('vip_checkin_status') || 0;
            this.vip_checkin_status = +vip_checkin_status
        },
		//获取vip状态
		status_checkin(){
			
			status_checkin({vip_code:this.$route.query.vip_code}).then(res=>{
				
				this.name=res.name
				
				this.vip_checkin_status=res.checkin_status
				
			})
			
		},
		// 领取
		handle_receive() {
			if (!this.verify_login()) return;
            if (this.vip_checkin_status) return this.$toast('您已领取')

            const {
                vip_code,
                from_code,
            } = this.$route.query
            const params = {
                vip_code,
                from_code,
            }
            promote_checkin(params).then(() => {
                this.$toast({
                    type: 'success',
                    message: '领取成功',
                });
                localStorage.setItem('vip_checkin_status', this.vip_checkin_status = 1) // vip领取状态0未领1已领
            })
            .catch(err => {
                this.$toast({
                    type: 'fail',
                    message: err.msg
                })
            })
		},
	},
};
</script>

<style lang="less" scoped>
@import './step_one.less';
</style>
